import(/* webpackMode: "eager", webpackExports: ["FraudProtection"] */ "/codebuild/output/src3024251350/src/101yapi.com/src/components/fraud/fraud-protection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3024251350/src/101yapi.com/src/modules/blog/templates/blog-post-template.tsx");
